// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__17aIK","dragIcon":"SortableItem_dragIcon__1jsaH","disabled":"SortableItem_disabled__s5JOp"};